import { Field, Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useApi } from '../../context/ApiProvider';
import ActivityIndicator from '../Helpers/ActivityIndicator';
import Card from '../Helpers/Card';
import { useLocale } from '../../localization/LocaleProvider';

export default function Preferences() {
  const Api = useApi();
  const [user, setUser] = useState(false);
  const [savePreferencesError, setSavePreferencesError] = useState(false);
  const [savePreferencesSuccess, setSavePreferencesSuccess] = useState(false);
  const [savePasswordError, setSavePasswordError] = useState(false);
  const [savePasswordSuccess, setSavePasswordSuccess] = useState(false);
  const { translate } = useLocale();

  useEffect(() => {
    Api.getSession().then(session => {
      if (!session?.ID) {
        return;
      }

      Api.get(`/administrators/${session.ID}`).then(user => {
        setUser(user);
      })
    })
  }, []);


  const saveSettings = async (values) => {
    setSavePreferencesError(false);
    setSavePreferencesSuccess(false);

    await Api.put(`/administrators/${user.ID}`, values).then(data => {
      setSavePreferencesSuccess('User settings saved successfully');
    }).catch(e => {
      setSavePreferencesError(e.error);
    }).finally(() => {
      setTimeout(() => {
        setSavePreferencesSuccess(false);
      }, 3000);
    })
  }

  const changePassword = async (values) => {
    setSavePasswordError(false);
    setSavePasswordSuccess(false);
    await Api.put(`/administrators/${user.ID}/password`, values).then(data => {
      setSavePasswordSuccess('Password changed successfully');
    }).catch(e => {
      setSavePasswordError(e.error);
    }).finally(() => {
      setTimeout(() => {
        setSavePasswordSuccess(false);
      }, 3000);
    })

  }


  return (
    <>
      <h2>{translate("Preferences")}</h2>
      <p>{translate("Here you can change the account settings to your Rolf-Administration account, such as changing your name, email and password.")}</p>
      <div className='grid-container'>
        <section className='grow'>
          <h4>{translate("User settings")}</h4>
          <Card>
            {savePreferencesError && <span className="formControlError formControl">{savePreferencesError}</span>}
            {savePreferencesSuccess && <span className="formControlSuccess formControl">{savePreferencesSuccess}</span>}
            <Formik
              enableReinitialize={true}
              initialValues={user}

              onSubmit={(values, { setSubmitting }) => {
                setSubmitting(true);
                saveSettings(values).then(() => {
                  setSubmitting(false);
                }).finally(() => {
                  setSubmitting(false);
                });
              }}
            >
              {({ isSubmitting }) => (

                <Form>
                  <label htmlFor="firstName">{translate("First name")}</label>
                  <Field type="text" name="firstName" id="firstName" className="formControl" required />
                  <label htmlFor="lastName">{translate("Last name")}</label>
                  <Field type="text" name="lastName" id="lastName" className="formControl" required />
                  <label htmlFor="email">{translate("E-mail")}</label>
                  <Field type="email" name="email" id="email" className="formControl" required />

                  <button type="submit" className="button" disabled={isSubmitting}>{translate("Save user settings")}{isSubmitting && <ActivityIndicator />}</button>
                </Form>
              )}
            </Formik>
            <span className='meta'>{translate("The email address you enter here is used to log in to Rolf Administration and is also used to reset your password.")}</span>
          </Card>
        </section>
        <section>
          <h4>{translate("Change password")}</h4>
          <Card>
            {savePasswordError && <span className="formControlError formControl">{savePasswordError}</span>}
            {savePasswordSuccess && <span className="formControlSuccess formControl">{savePasswordSuccess}</span>}
            <Formik
              initialValues={{
                currentPassword: '',
                newPassword: '',
                newPasswordVerify: ''
              }}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                if(values.newPassword.length < 10) {
                  setSavePasswordError('Password must be at least 10 characters long');
                  setTimeout(() => {
                    setSavePasswordError(false);
                  }, 3000);
                  return;
                }

                if(values.newPassword !== values.newPasswordVerify) {
                  setSavePasswordError('Passwords do not match');
                  setTimeout(() => {
                    setSavePasswordError(false);
                  }, 3000);
                  return;
                }

                setSubmitting(true);
                changePassword(values).then(() => {
                  resetForm();
                }).finally(() => {
                  setSubmitting(false);
                });
              }}
            >
              <Form>
                <label htmlFor="currentPassword">{translate("Current password")}</label>
                <Field type="password" name="currentPassword" id="currentPassword" className="formControl" required />
                <label htmlFor="newPassword">{translate("New password")}</label>
                <Field type="password" name="newPassword" id="newPassword" className="formControl" required />
                <label htmlFor="newPasswordVerify">{translate("Repeat new password")}</label>
                <Field type="password" name="newPasswordVerify" id="newPasswordVerify" className="formControl" required />
                <button type="submit" className="button">{translate("Change password")}</button>
              </Form>
            </Formik>
            <span className='meta'>
              {translate("Password must be at least 10 characters long and cannot be the same as your current password.")}
              {translate("Password must not be the same as your username/email or other personal information.")}
            </span>
          </Card>
        </section>
      </div>
    </>
  )
}